<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SystemMaintenance.TemplateApplicationSettings')"
    width="650px"
    :close-on-click-modal="false"
    class="details-view"
  >
    <el-form class="main-content" style="margin-top: 10px;margin-left: 10px">
      <el-form-item>
        <span slot="label" class="title" style="font-weight: bold;">{{ $t('SystemMaintenance.MatchingSettings') }}</span>
      </el-form-item>
      <el-form-item style="margin-left: 10px;">
        <el-checkbox v-model="form.forbidManualChangeTemplate">{{ $t('SystemMaintenance.ManualSOPTemplatesIsAllowed') }}</el-checkbox>
      </el-form-item>
      <el-form-item style="margin-left: 10px;">
        <el-checkbox v-model="form.hidePromptOnTemplateAutoMatch">{{ $t('SystemMaintenance.DoTemplateIsAutomaticallyTemplate') }}</el-checkbox>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="okHandler">{{ $t('Message.Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getSopTemplateConfig, saveSopTemplateConfig } from '@/api/sysManage/baseConfig/businessManage'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'SopTemplateConfigDialog',
  props: {
    visible: { type: Boolean, required: true },
    lob: { type: String, required: true }
  },
  data() {
    return {
      innerVisible: false,
      form: { forbidManualChangeTemplate: false, hidePromptOnTemplateAutoMatch: false }
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          const res = await getSopTemplateConfig({ lob: this.lob })
          this.form = res.data
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.form = { forbidManualChangeTemplate: false, hidePromptOnTemplateAutoMatch: false }
      }
    }
  },
  methods: {
    okHandler() {
      const loading = getLoading4Cxt(this)
      saveSopTemplateConfig(this.form).then(() => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.innerVisible = false
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>
